import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { publicCompanyLeadsTransformer } from '../services/publicCompanyLeadsTransformer'

type usePublicCompanyLeadsProps<T> = {
  filters?: {
    pageSize?: number,
    search?: string
    state?: string
    creatorId?: string
    showOnlyArchived?: boolean
  }
  mapper?: (data: any) => T
}

export const usePublicCompanyLeads = <T,>({
  filters: { pageSize, search = '', state, creatorId, showOnlyArchived } = {},
  mapper,
}: usePublicCompanyLeadsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['publicCompanyLeads', pageSize, search, state, creatorId, showOnlyArchived],
    queryFn: () => {
      const params = {
        page_size: pageSize,
        search,
        'q[archived_at_not_null]': showOnlyArchived ? true : undefined,
        'q[state_eq]': state,
        'q[creator_id_eq]': creatorId,
      }

      return privateAxios.get('/funnel/public/leads', {
        params,
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: (mapper || publicCompanyLeadsTransformer)(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}
